// extracted by mini-css-extract-plugin
export default {"link":"qeVEviwxGtmBXmo8R6Ib","inline":"kGIMyrokRmcqKfCtgYkR","full-width":"QXzgK5vtkhF5Yx907mMg"};